<div class="diagnostic-journey container-fluid bg-lightblue">
    <div class="container-xxxl disease-page-top-element-padding">
        <div class="row gx-4 gy-4 py-5 align-items-start">
            <div class="col-12 col-xl-6 pe-lg-5">
                <div class="container-fluid pb-32">
                    <div class="row">
                        <h2 class="section-heading text-blue border-blue">{{ article.title }}</h2>
                    </div>
                </div>
                <clamper class="diagnostic-journey-body fs-6 fs-lg-18" [maxLines]="bodyMaxLines" [text]="article.bodyText"></clamper>
            </div>
            <div class="col-12 col-xl-6 d-print-none">
                <img class="img-fluid rounded-3 w-100" [src]="imgUrl" alt="" />
            </div>
        </div>
    </div>
</div>
